import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import AbsoluteDropdownContainer from 'ui-library/AbsoluteDropdownContainer';
import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {BLUE} from 'ui-library/Colors';
import IndeterminateCheckbox from 'ui-library/IndeterminateCheckbox';
import {ElementMouseEvent, InputChangeEvent} from 'util/Types';

export interface LegacyColumnFilterDropdownProps {
  buttonSize: ButtonSize;
  onToggleAllFilters: (e: InputChangeEvent) => void;
  onToggleFilter: (index: number) => void;
  columns: Array<{
    header: string;
    hidden: boolean;
  }>;
}

interface State {
  isOpen: boolean;
}

export default class LegacyColumnFilterDropdown extends React.Component<LegacyColumnFilterDropdownProps> {
  state: State = {
    isOpen: false,
  };

  private closeIfOpen = (): void => {
    this.setState({isOpen: false});
  };

  private toggleOpen = (e: ElementMouseEvent): void => {
    this.setState({isOpen: !this.state.isOpen});
    this.handleStopPropagation(e);
  };

  private handleStopPropagation = (e: ElementMouseEvent): void => {
    e.stopPropagation();
  };

  private renderMenu(): JSX.Element {
    return (
      <div className="dropdown-menu columnFilterDropdown-menu" onClick={this.handleStopPropagation}>
        <label className="columnFilterDropdown-item">
          <div className="columnFilterDropdown-checkbox">
            <IndeterminateCheckbox
              items={this.props.columns}
              selectedMap={(column) => !column.hidden}
              onChange={this.props.onToggleAllFilters}
            />
          </div>
          <div>Show All Columns</div>
        </label>
        <div className="columnFilterDropdown-border" />
        {(() =>
          this.props.columns.map((column, index) => {
            const handleToggleFilter = (): void => {
              this.props.onToggleFilter(index);
            };
            return (
              <label className="columnFilterDropdown-item" key={`filter-${column.header}`}>
                <div className="columnFilterDropdown-checkbox">
                  <input
                    type="checkbox"
                    checked={!column.hidden}
                    onChange={handleToggleFilter}
                    className={css(styles.checkbox)}
                  />
                </div>
                <div>{column.header}</div>
              </label>
            );
          }))()}
      </div>
    );
  }

  render(): JSX.Element {
    return (
      <Tooltip container="body" placement={TooltipPlacement.TOP} title="Filter Fields...">
        <div className="columnFilterDropdown">
          <AbsoluteDropdownContainer
            menu={this.renderMenu()}
            onRequestClose={this.closeIfOpen}
            open={this.state.isOpen}
          >
            <Button
              buttonStyle={ButtonStyle.CIRCLE_ICON}
              className={classNames({'is-active': this.state.isOpen})}
              icon="filter"
              onClick={this.toggleOpen}
              size={this.props.buttonSize}
            />
          </AbsoluteDropdownContainer>
        </div>
      </Tooltip>
    );
  }
}

const styles = StyleSheet.create({
  checkbox: {
    accentColor: BLUE,
  },
});
